import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, InputGroup } from 'react-bootstrap';
import { Button, Spin } from 'antd';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../../../components/formatters/numberFormatter';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../../../components/loader/loader';

const Total = (props) => {

    const { api, userData, settingData, mainCurrency, secondaryCurrency } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);


    const { totalDebit, totalCredit, secondaryTotalDebit, secondaryTotalCredit } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const today = new Date().toISOString().split('T')[0];





    return (
        <div>


            <Row>
                <Col md={3}>
                    <label>Total Debit</label>
                </Col>
                <Col>
                    <InputGroup>
                        <input type="text" value={numberFormatter(totalDebit)} className="form-control" disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>

                <Col>
                    <InputGroup>
                        <input type="text" value={numberFormatter(secondaryTotalDebit)} className="form-control" disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>


            <Row className='mb-5'>
                <Col md={3}>
                    <label>Total Credit</label>
                </Col>
                <Col>
                    <InputGroup>
                        <input type="text" value={numberFormatter(totalCredit)} className="form-control" disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>

                <Col>
                    <InputGroup>
                        <input type="text" value={numberFormatter(secondaryTotalCredit)} className="form-control" disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>

            <Row>
            <Col md={6}>
            </Col>
                <Col md={2}>
                    {(totalCredit !== totalDebit) &&
                        <FcCancel size={32} />
                    }
                    {(totalCredit == totalDebit) &&
                        <FaCheck size={30} color={'#4caf50'} />
                    }
                </Col>
            </Row>

        </div>
    )
}


export default Total;